module.exports = __webpack_public_path__ + "img/ouzel-aq-project.14a00b61.png";